const { AssetName } = require('./AssetName');

function flattenObject(object) {
    return flattenRecursive(object);

    function flattenRecursive(object, prefix = false, result = null) {
        result = result || {};

        if (prefix && typeof object === 'object' && object !== null && Object.keys(object).length === 0) {
            result[prefix] = Array.isArray(object) ? [] : {};
            return result;
        }

        prefix = prefix ? prefix + '.' : '';

        for (const i in object) {
            if (Object.prototype.hasOwnProperty.call(object, i)) {
                if (typeof object[i] === 'object' && object[i] !== null) {
                    flattenRecursive(object[i], prefix + i, result);
                } else {
                    result[prefix + i] = object[i];
                }
            }
        }

        return result;
    }
}

function unflattenObject(object) {
    const result = {};
    for (const i in object) {
        if (Object.prototype.hasOwnProperty.call(object, i)) {
            const keys = i.match(/^\.+[^.]*|[^.]*\.+$|(?:\.{2,}|[^.])+(?:\.+$)?/g);
            keys.reduce((r, e, j) => {
                return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 === j ? object[i] : {}) : []);
            }, result);
        }
    }
    return result;
}

function createCleanAssetName(assetName) {
    if (AssetName[assetName]) {
        assetName = AssetName[assetName]
    }

    return assetName.replace(/([A-Z])/g, ' $1');
}

function generateUUID() {
    let _lut = [];

    for (let i of range(0, 256)) {
        _lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
    }

    let d0 = Math.random() * 0xffffffff | 0;
    let d1 = Math.random() * 0xffffffff | 0;
    let d2 = Math.random() * 0xffffffff | 0;
    let d3 = Math.random() * 0xffffffff | 0;
    let uuid = _lut[d0 & 0xff] + _lut[d0 >> 8 & 0xff] + _lut[d0 >> 16 & 0xff] + _lut[d0 >> 24 & 0xff] + '-' +
        _lut[d1 & 0xff] + _lut[d1 >> 8 & 0xff] + '-' + _lut[d1 >> 16 & 0x0f | 0x40] + _lut[d1 >> 24 & 0xff] + '-' +
        _lut[d2 & 0x3f | 0x80] + _lut[d2 >> 8 & 0xff] + '-' + _lut[d2 >> 16 & 0xff] + _lut[d2 >> 24 & 0xff] +
        _lut[d3 & 0xff] + _lut[d3 >> 8 & 0xff] + _lut[d3 >> 16 & 0xff] + _lut[d3 >> 24 & 0xff];

    return uuid.toUpperCase();
}

function* range(start, stop, step) {
    if (stop === undefined) {
        stop = start;
        start = 0;
    }

    if (!step) {
        step = 1;
    }

    for (let i = start; step > 0 ? i < stop : i > stop; i += step) {
        yield i;
    }
}

function truncateString(string, maxLength = 45) {
    if (string && string.length > maxLength) {
        return string.slice(0, maxLength) + '...';
    }

    return string;
}

module.exports = {
    flattenObject,
    unflattenObject,
    createCleanAssetName,
    generateUUID,
    truncateString
};
